// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
import SmartyPants from '@vendors/smartypants';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class ParagraphAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `ParagraphModule` to the `ParagraphToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        this.validate(object, {
            content: {
                presence: true
            },
            'content.text': {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        const { text } = object.content;
        return {
            content: text,
            raw: this.decodeHtml(text),
            type: TokenType.Paragraph
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `ParagraphToken` to the `ParagraphModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        const { content: text } = token;
        return {
            ...getModuleBase(),
            content: { text: SmartyPants(text, '1') },
            driver: ModuleDriver.Paragraph
        };
    }
    decodeHtml(html) {
        if (typeof document === 'undefined') {
            return html;
        }
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }
}
